'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Row = require('./Row');

var _Row2 = _interopRequireDefault(_Row);

var _Loading = require('./Loading');

var _Loading2 = _interopRequireDefault(_Loading);

var _NoData = require('./NoData');

var _NoData2 = _interopRequireDefault(_NoData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Body = function Body(_ref) {
  var loading = _ref.loading,
      noDataText = _ref.noDataText,
      data = _ref.data,
      columns = _ref.columns,
      setRowClass = _ref.setRowClass,
      specialRow = _ref.specialRow;
  return _react2.default.createElement(
    'tbody',
    { className: 'ui-table__body' },
    loading || !data.length ? _react2.default.createElement(
      'tr',
      { className: 'ui-table__row' },
      _react2.default.createElement(
        'td',
        {
          className: 'ui-table__cell',
          colSpan: columns.length
        },
        loading ? _react2.default.createElement(_Loading2.default, null) : _react2.default.createElement(_NoData2.default, { text: noDataText })
      )
    ) : data.map(function (rowData, index) {
      return _react2.default.createElement(_Row2.default, {
        rowData: rowData,
        columns: columns,
        key: rowData.__id || index,
        setRowClass: setRowClass,
        specialRow: specialRow
      });
    })
  );
};

Body.propTypes = {
  loading: _propTypes2.default.bool,
  noDataText: _propTypes2.default.string,
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({}).isRequired).isRequired,
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  setRowClass: _propTypes2.default.func,
  specialRow: _propTypes2.default.func
};

exports.default = Body;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-table/lib/RpTable/components/Body.js
// module id = 494
// module chunks = 0